<template>
  <div class="form" v-if="brand">
    <Header :brand="brand"></Header>
    <Baner :brand="brand"></Baner>
    <Form
      :config="{
        months: getMonths,
        financing: getFinancing,
        models: getModelsByBrandId(brand.id),
        uniqueBrands: getUniqueBrands,
        modelsByBrandName: getModelsByBrandName(form.prefered_brand),
        years: getYears,
        hours: getHours,
        localization: getLocalizationByBrandId(brand.id),
        localizationByBrandName: getLocalizationByBrandName(form.prefered_brand),
      }"
      v-on:typing="form = $event"
      v-on:submit="
        submit({
          ...form,
          brand_id: brand.id,
          brand: form.prefered_brand ? null : '- nie wybrano -',
        }).then((r) => {
          if (r.status == 200) {
            $router.push('/success');
          }
        })
      "
    ></Form>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Baner from "../components/Baner.vue";
import Form from "../components/Form.vue";
import Footer from "../components/Footer.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      brand: null,
      form: {},
    };
  },
  components: {
    Header,
    Baner,
    Footer,
    Form,
  },
  computed: {
    ...mapGetters([
      "getBrandByUrl",
      "getMonths",
      "getFinancing",
      "getModelsByBrandId",
      "getYears",
      "getHours",
      "getSubmitState",
      "getUniqueBrands",
      "getModelsByBrandName",
      "getLocalizationByBrandId",
      "getLocalizationByBrandName",
    ]),
  },
  methods: {
    ...mapActions(["submit"]),
  },
  mounted() {
    this.brand = this.getBrandByUrl(this.$route.params.url);
  },
};
</script>
